const Loader = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-secondary m-1" role="status"></div>
    </div>
  );
};

export default Loader;
